'use client'

import { ReactNode } from 'react'
import ErrorPageComponent from '@/app/_components/ErrorPage/ErrorPageComponent'
import Error from 'next/error'

type Props = {
  error: Error
  unstable_retry: () => void
}

/**
 * Root segment error boundary.
 *
 * Handles `/` (landing page) and `/lock`, plus any route without a closer boundary.
 * Root layout errors are not caught here — those fall through to `global-error.tsx`.
 */
const ErrorPage = ({ error, unstable_retry: onRetry }: Props): ReactNode => (
  <ErrorPageComponent error={error} onRetry={onRetry} withHeader />
)

export default ErrorPage
